import React from 'react';
import {Skeleton} from '@material-ui/lab';
import {Typography, TypographyProps} from '@material-ui/core';

export const paragraphWidths = {
    lg: [98, 97, 95, 98, 97, 98],
    sm: [95, 100, 90],
    sma: [10, 100, 95, 90],
    smb: [10, 95, 100, 90],
    radio: [98, 97]
};

export type ParagraphSkeletonProps = TypographyProps & {
    component?: any;
    type?: 'lg' | 'sm' | 'sma' | 'smb' | 'radio';
};

const ParagraphSkeleton: React.FC<ParagraphSkeletonProps> = ({
    type = 'lg',
    component = 'div',
    style = {margin: '15px 0'},
    ...rest
}) => {
    const pWidths = paragraphWidths[type];
    return (
        <Typography component={component} style={style} {...rest}>
            {pWidths.map((width, i) => (
                <Skeleton component={Typography} key={i} width={`${width}%`} />
            ))}
        </Typography>
    );
};

export default ParagraphSkeleton;
